module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Video Interview"}}')
  delete Component.options._Ctor
}
